<div class="contain" [ngClass]="{'distributed':data?.isFromPublish}" >
    <!-- <div class="close"><img class="pointer" src="/assets/images/popup-recipient/cancel.svg" (click)="close()"> 
    </div>-->
    <ng-container *ngIf="data?.isFromPublish">
        <p class="msg" translate>success.message.distributedQuestionnaire</p>
        <div>
            <svg-icon svgClass="svg-img img margin-r margin-t" src="/assets/images/great-images/distributed.svg"></svg-icon>
        </div>
    </ng-container>
    <ng-container *ngIf="data?.isFromPublishAnswers">
        <p class="msg" translate>success.message.distributedAnswers</p>
        <div>
            <svg-icon svgClass="svg-img img margin-r margin-t" src="/assets/images/great-images/distributed.svg"></svg-icon>
        </div>
    </ng-container>
    <ng-container *ngIf="data?.isFromReminder">
        <p class="msg" translate>success.message.createReminder</p>
        <div>
            <svg-icon svgClass="svg-img img" src="/assets/images/great-images/createReminder.svg"></svg-icon>
        </div>
    </ng-container>
    <ng-container *ngIf="data?.isFromGroup">
        <p class="msg" translate>success.message.createGroup</p>
        <div>
            <svg-icon svgClass="svg-img img margin-t" src="/assets/images/messages/create-groups.svg"></svg-icon>
        </div>
    </ng-container>
    <ng-container *ngIf="data?.isFromApprovalResponse">
        <p class="msg" translate>success.message.approvalRequestResponded</p>
        <div>
            <svg-icon svgClass="svg-img img margin-t" src="/assets/images/messages/create-groups.svg"></svg-icon>
        </div>
    </ng-container>

    <div (click)="close()" class="btn-back pointer">
        <p translate>success.close</p>
    </div>
    <!-- <div (click)="back()" class="btn-back pointer" *ngIf="data?.isFromPublish; else backButton">
        <p translate >success.view</p>
    </div> -->
    <!-- <ng-template #backButton>
        <div (click)="back()" class="btn-back pointer">
            <p translate>success.back</p>
        </div>
    </ng-template> -->
</div>